import Reducer from "./reducers";
export default Reducer;
